import { render, staticRenderFns } from "./display-widget.vue?vue&type=template&id=d9b467f6&scoped=true&"
import script from "./display-widget.vue?vue&type=script&lang=ts&"
export * from "./display-widget.vue?vue&type=script&lang=ts&"
import style0 from "./display-widget.vue?vue&type=style&index=0&id=d9b467f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b467f6",
  null
  
)

export default component.exports